import React from 'react';
import styled from 'styled-components';
import { Tooltip, Icon, IconLookup } from 'component-library-and-tools';

const StyledWeightHeaderCellContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

const StyledHeaderCellLabel = styled.span`
  margin-right: 0.75rem;
  font-weight: 700;
`;

const WeightHeaderCell = () => (
  <StyledWeightHeaderCellContainer>
    <StyledHeaderCellLabel>Weight</StyledHeaderCellLabel>
    <Tooltip
      limitWidth={150}
      content='Optional: Adjust the Source Weight based on the confidence in the intel source. By default, all sources are set to 1. The scale goes from 1 (lowest influence) to 5 (highest influence).'
    >
      <Icon icon={IconLookup.QUESTION_CIRCLE} />
    </Tooltip>
  </StyledWeightHeaderCellContainer>
);

export { WeightHeaderCell };
